import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PageNotFound.scss";

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/khong-tim-thay-trang"); 
  }, [navigate]);

  const goBack = () => {
    navigate("/"); 
  };

  return (
    <div className="notfound-page">
      <section className="notfound-section">
        <div className="notfound-content">
          <div
            className="group-content"
            style={{
              backgroundImage: "url('/assets/images/home/image404.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right center",
              backgroundSize: "contain",
            }}
          >
            <h1 className="notfound-title">404</h1>
            <h1 className="text-content">Trang không tìm thấy</h1>
            <p className="notfound-subcontent">
              Trang bạn vừa truy cập không tồn tại hoặc đã rời đi. Hãy thử lại
              sau nhé
            </p>
            <button className="button-back" onClick={goBack}>Về trang chủ</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PageNotFound;
